import { INavData } from '@coreui/angular';
import { environment } from 'environments/environment';


interface NavAttributes {
  [propName: string]: any;
}
interface NavWrapper {
  attributes: NavAttributes;
  element: string;
}
interface NavBadge {
  text: string;
  variant: string;
}
interface NavLabel {
  class?: string;
  variant: string;
}

export interface NavData {
  name?: string;
  url?: string;
  icon?: string;
  badge?: NavBadge;
  title?: boolean;
  children?: NavData[];
  variant?: string;
  attributes?: NavAttributes;
  divider?: boolean;
  class?: string;
  label?: NavLabel;
  wrapper?: NavWrapper;
}

export var navItems: INavData[] = [
  {
    name: 'Dashboard',
    url: '/home',
    icon: 'icon-speedometer'
  },
  {
    name: 'Leads',
    url: '/leads',
    icon: 'bi bi-person-lines-fill',
    children: [
      {
        name: 'Active Leads',
        url: '/leads/all-leads',
        icon: 'bi bi-people-fill'
      },
      {
        name: 'Already Worked Leads',
        url: '/leads/inactive-leads',
        icon: 'bi bi-person-dash'
      },
      {
        name: 'Businesses',
        url: '/leads/businesses',
        icon: 'bi bi-building'
      },
      {
        name: 'Lists',
        url: '/leads/lists',
        icon: 'bi bi-card-list'
      },
      {
        name: 'Bulk Add',
        url: '/leads/bulk-add-leads',
        icon: 'bi bi-file-earmark-excel-fill'
      },
      {
        name: 'Distribute',
        url: '/leads/distributions',
        icon: 'bi bi-shuffle'
      },
      {
        name: 'Leads from Email',
        url: '/leads/mailbox',
        icon: 'bi bi-envelope'
      }
    ]
  },
  {
    name: 'Engagements',
    url: '/engagements',
    icon: 'bi bi-arrow-left-right',
    children: [
      {
        name: 'All Engagements',
        url: '/engagements/all-engagements',
        icon: 'bi bi-arrow-left-right'
      },
      {
        name: 'Calls',
        url: '/engagements/calls',
        icon: 'bi bi-telephone-fill'
      },
      {
        name: 'Messages',
        url: '/engagements/messages',
        icon: 'bi bi-envelope-fill'
      },
      {
        name: 'Visits',
        url: '/engagements/visits',
        icon: 'bi bi-geo-alt-fill'
      },
      {
        name: 'Tasks',
        url: '/todo/grid',
        icon: 'bi bi-list-task'
      },
      // {
      //   name: 'Campaigns',
      //   url: '/engagements/campaigns',
      //   icon: 'bi bi-megaphone-fill'
      // }
    ]
  },
  {
    divider: true
  },
  {
    name: 'To Do',
    url: '/todo/to-do-kanban',
    icon: 'bi bi-list-task'
  },
  {
    divider: true
  },
  {
    name: 'Opportunities',
    url: '/opportunities/opportunity-list',
    icon: 'bi bi-currency-dollar',
    children: [
      {
        name: 'Deals',
        icon: 'fa fa-handshake-o',
        url : "/opportunities/opportunity-list"
      },
      {
        name: 'Payments',
        icon: 'bi bi-currency-dollar',
        url : "/opportunities/payments"
      }
    ]
  },
  {
    divider: true
  },
  {
    name: 'Metrics',
    url: '/metrics',
    icon: 'fa fa-line-chart',
    badge: {
      variant: 'info',
      text: 'NEW'
    },
    children: [
      // {
      //   name: 'Charts',
      //   icon: 'bi bi-pie-chart-fill',
      //   url : ['/metrics', {outlets: {'metric': ['chart']}}],
      //   linkProps : {routerLinkActiveOptions : {exact : true}}
      // },
      {
        name: 'All Metrics',
        icon: 'bi bi-graph-up',
        url : "/metrics/performance",
        linkProps : {routerLinkActiveOptions : {exact : true}}
      },
      {
        name: 'Source Reports',
        icon: 'fa fa-database',
        url : "/metrics/source-report"
      },
      {
        name: 'Attendance Metrics',
        icon: 'bi bi-hand-index',
        url : "/metrics/attendance"
      },
      // {
      //   name: 'Call Metrics',
      //   url: ['/metrics', {outlets: {'metric': ['calling']}}],
      //   icon: 'bi bi-telephone-fill',
      //   linkProps : {routerLinkActiveOptions : {exact : true}}
      // },
    ]
  },
  {
    divider: true
  },
  {
    name: 'Activities',
    url: '/activities/activities-feed',
    icon: 'icon-chart'
  },
  {
    divider: true
  },
  {
    name: 'Live Location',
    url: '/location',
    icon: 'icon-location-pin'
  },
  {
    divider: true
  },
  {
    name: 'Data Exports',
    url: '/export',
    icon: 'bi bi-cloud-arrow-down-fill'
  }
];
